module.exports = __webpack_public_path__ + "img/mask-bg.36b4e406.png";